<template>
  <div class="personnelList">
    <el-card>
      <el-button type="primary" slot="header" @click="jump">{{$t('lang.addpersonnelBtn')}}</el-button>
      <el-table
        :height="tableData.length > 0 ? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight109"
        :data="tableData"
        class="wid100"
        :row-class-name="tableRowClassName"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55" v-if="this.personnelListcheckbox"></el-table-column>
        <el-table-column
          type="index"
          :index="indexMethod"
          align="center"
          :label="$t('lang.lab_index')"
          width="100px"
        ></el-table-column>
        <el-table-column prop="name" :label="$t('lang.lab_groupname')">
          <template slot-scope="scope">
            <el-tooltip
              placement="top"
              effect="light"
              v-if="scope.row.name&&scope.row.name.length> require('@/config/enum').tableDatamaxlength"
              :disabled="false"
            >
              <div slot="content">
                <span>{{ scope.row.name }}</span>
              </div>
              <div class="conctentstyle">
                {{ scope.row.name.substring(0, require('@/config/enum').tableDatamaxlength) | valueIsNull }}
                <span
                  v-if="scope.row.name.length>require('@/config/enum').tableDatamaxlength"
                >...</span>
              </div>
            </el-tooltip>
            <el-tooltip placement="top" effect="light" v-else :disabled="true">
              <div class="conctentstyle">{{ scope.row.name | valueIsNull }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="staffNames" :label="$t('lang.lab_groupmembers')">
          <template slot-scope="scope">
            <el-tooltip
              placement="top"
              effect="light"
              v-if="scope.row.staffNames&&scope.row.staffNames.length> require('@/config/enum').tableDatamaxlength"
              :disabled="false"
            >
              <div slot="content">
                <span v-for="(i,index) in scope.row.staffNamesTip" :key="index">
                  {{ i }};
                  <br />
                  <br />
                </span>
              </div>
              <div>
                {{ scope.row.staffNames.substring(0, require('@/config/enum').tableDatamaxlength) | valueIsNull }}
                <span
                  v-if="scope.row.staffNames.length>require('@/config/enum').tableDatamaxlength"
                >...</span>
              </div>
            </el-tooltip>
            <el-tooltip placement="top" effect="light" v-else :disabled="true">
              <div slot="content">
                <span v-for="(i,index) in scope.row.staffNamesTip" :key="index">
                  {{ i }};
                  <br />
                  <br />
                </span>
              </div>
              <div>{{ scope.row.staffNames | valueIsNull }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column
          prop="operation"
          :label="$t('lang.lab_operation')"
          fixed="right"
          :width="require('@/config/enum').opr_width2"
        >
          <template slot-scope="scope">
            <el-button @click="edit(scope.row.id)">{{$t('lang.btn_modify')}}</el-button>
            <el-button
              class="orange"
              @click="deletetable(scope.row.id)"
            >{{$t('lang.btn_delete')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNum"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :page-count="pageCount"
      />
    </el-card>
    <el-dialog
      :visible.sync="show"
      :close-on-click-modal="false"
      center
      top="130px"
      width="600px"
      :title="title"
      @closed="handleDialogClosed"
    >
      
        <el-form
          :rules="rules"
          ref="form"
          :model="form"
          :label-width="require('@/config/enum').c_ws4"
          :label-suffix="require('@/config/enum').c_colon"
        >
          <el-form-item :label="$t('lang.lab_groupnames')" prop="name">
            <el-input
              v-model="form.name"
              maxlength="50"
              :placeholder="$t('lang.lab_please_Input')+$t('lang.lab_groupnames')"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('lang.lab_groupmemberss')" prop="searchUnit">
            <el-select
              class="select"
              v-model="form.searchUnit"
              multiple
              :multiple-limit="7"
              filterable
              :placeholder="$t('lang.lab_groupnubmax')"
            >
              <el-option
                v-for="item in form.group"
                :key="item.id"
                :label="item.idNo"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      
      <div slot="footer">
        <el-button @click="handleDialogClosed()">{{$t('lang.btn_rest')}}</el-button>
        <el-button
          type="primary"
          :disabled="isDisabled"
          @click="onSubmit('form')"
        >{{$t('lang.btn_save')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
/**
 *@ClassName:personnelList
 *@Description:人员分配
 *@author:孙斯维
 *@Copyright:格众科技
 *@date:2020-02-19
 */
export default {
  data() {
    return {
      title: this.$i18n.t('lang.modifygroups'),
      id: '', // 区分新增和修改
      saveData: '', // 存储json字符串
      isDisabled: true, // 确定按钮置灰
      form: {
        name: '',
        searchUnit: [],
        group: []
      }, // 通过id查询对象
      show: false, // 弹框开关
      multipleSelection: [], // 多选框
      pageCount: 0, // 总页数
      pageNum: 1, // 页数
      pageSize: 10, // 每页显示数
      tableData: [], // 列表数组
      personnelListcheckbox: require('@/config/enum').personnelListcheckbox, // 是否隐藏复选框
      rules: {
        name: [
          {
            required: true,
            message: this.$i18n.t('lang.groupnamerule'),
            trigger: 'blur'
          }
        ],
        searchUnit: [
          {
            required: true,
            message: this.$i18n.t('lang.grouppeoplerule'),
            trigger: 'change'
          }
        ]
      }
    }
  },
  created() {
    this.personlist()
    this.groupMember()
  },
  watch: {
    form: {
      handler(newVal, oldVal) {
        let tempRule = JSON.stringify(newVal)
        if (tempRule === this.saveData) {
          this.isDisabled = true
            console.log('true')
        } else {
          this.isDisabled = false
            console.log('false')
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    // ID序号功能
    indexMethod(index) {
      return (this.pageNum - 1) * this.pageSize + index + 1
    },
    tableRowClassName({ row, rowIndex }) {
      return rowIndex % 2 === 0 ? 'row-dark' : ''
    },
    // 监听关闭dialog
    handleDialogClosed() {
      this.form.name = ''
      this.form.searchUnit = []
      setTimeout(() => {
        this.$refs.form.clearValidate()
      }, 0)
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 查询组list
    groupMember() {
      let loading = this.$loading()
      this.$get(
        `/staffs?gardenId=${this.$store.getters.gardenId}&pageSize=999&pageNo=1`
      ).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.form.group = res.list
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 人员分配列表
    personlist() {
      let loading = this.$loading()
      this.$get(
        `/patrolPersonnelAllocation?GardenId=${this.$store.getters.gardenId}&pageSize=${this.pageSize}&pageNo=${this.pageNum}`
      ).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.tableData = res.list
            for (let i = 0; i < this.tableData.length; i++) {
              if (this.tableData[i].staffNames) {
                this.tableData[i].staffNamesTip = this.tableData[i].staffNames.split(',')
              }
            }
            this.pageCount = res.pageCount
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    handleCurrentChange(val) {
      this.pageNum = val
      this.personlist()
    },
    // 切换每页显示多少数据
    handleSizeChange(val) {
      this.pageNum = 1
      this.pageSize = val
      this.personlist()
    },
    edit(id) {
      this.title = this.$i18n.t('lang.modifygroups')
      this.id = id
      let loading = this.$loading()
      this.$get(`/patrolPersonnelAllocationById/` + id).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.form.name = res.patrolPersonnelAllocation.name
            var group = []
            for (var i = 0; i < res.selectedStaffs.length; i++) {
              group.push(parseInt(res.selectedStaffs[i]))
            }
            this.form.searchUnit = group
            this.saveData = JSON.stringify(this.form)
            this.show = true
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    jump() {
      this.show = true
      this.id = ''
      this.title = this.$i18n.t('lang.addgroups')
    },
    commit() {
      this.pageNum = 1
      this.personlist()
    },
    // 修改保存
    onSubmit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.id === '') {
            let loading = this.$loading()
            let params = {
              GardenId: this.$store.getters.gardenId,
              GroupMems: this.form.searchUnit.toString(),
              Name: this.form.name
            }
            this.$post(`/patrolPersonnelAllocation/`, params).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message.success(this.$i18n.t('lang.lab_save_success'))
                  this.commit()
                  this.show = false
                }
                setTimeout(() => {
                  loading.close()
                }, 200)
              },
              error => {
                loading.close()
                this.$message.error(error)
              }
            )
          } else {
            let params = {
              GardenId: this.$store.getters.gardenId,
              Name: this.form.name,
              GroupMems: this.form.searchUnit.join(',')
            }
            let loading = this.$loading()
            this.$patch(`/patrolPersonnelAllocation/${this.id}`, params).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message.success(
                    this.$i18n.t('lang.lab_modify_success')
                  )
                  this.commit()
                  this.show = false
                }
                setTimeout(() => {
                  loading.close()
                }, 200)
              },
              error => {
                loading.close()
                this.$message.error(error)
              }
            )
          }
        }
      })
    },
    deletetable(id) {
      let loading = this.$loading()
      this.$confirm(
        this.$i18n.t('lang.lab_isdelete'),
        this.$i18n.t('lang.lab_prompt'),
        {
          confirmButtonText: this.$i18n.t('lang.btn_confirm'),
          cancelButtonText: this.$i18n.t('lang.btn_cancel'),
          type: 'warning'
        }
      )
        .then(() => {
          this.$delete(`/patrolPersonnelAllocation/` + id).then(
            res => {
              loading.close()
              if (res && res.errCode === 0) {
                this.$message({
                  type: 'success',
                  message: this.$i18n.t('lang.lab_del_success')
                })
                this.commit()
              }
            },
            error => {
              loading.close()
              this.$message.error(error)
            }
          )
        })
        .catch(() => {
          loading.close()
          this.$message({
            type: 'info',
            message: this.$i18n.t('lang.lab_del_can')
          })
        })
    }
  }
}
</script>

<style lang="scss">
</style>
